import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { config } from "~/data";
import { article as articleData } from "~/data/article";
import { useArticleUtils } from "~/lib/hooks/article-utils";
import type { articleFooterArticle$key } from "~/queries/__generated__/articleFooterArticle.graphql";

import { GenericArticleFooter } from "./generic-article-footer";
import { MorningStudioArticleFooter } from "./morning-studio-article-footer";

type Props = {
  articleRecommendation?: {
    articleIds: string[];
    recommendationId: string;
  };
  className?: string;
  reference: articleFooterArticle$key;
};
export const ArticleFooter: FunctionComponent<Props> = ({
  articleRecommendation,
  className,
  reference: reference_,
}) => {
  const article = useFragment(
    graphql`
      fragment articleFooterArticle on Article {
        ...articleUtilsArticle
        ...morningStudioArticleFooterContent
        ...genericArticleFooterArticle
      }
    `,
    reference_,
  );

  const { getArticleType } = useArticleUtils();

  switch (getArticleType(article)) {
    case articleData.types.studio.entityId:
      return <MorningStudioArticleFooter className={className} reference={article} />;
    default:
      return config.features.enableInfiniteScroll && articleRecommendation?.articleIds.length ? (
        <GenericArticleFooter
          className={className}
          {...articleRecommendation}
          reference={article}
        />
      ) : null;
  }
};

ArticleFooter.displayName = "ArticleFooter";
